<template>
  <v-dialog v-model="model" max-width="1200px">
    <v-card flat>
      <v-card-title class="d-flex justify-space-between py-2">
        <p class="h5 mb-0">{{ title }}</p>

        <v-btn flat icon @click="close">
          <v-icon :icon="mdiWindowClose" small color="primary" />
        </v-btn>
      </v-card-title>

      <v-divider />

      <v-card-text class="pb-4">
        <v-container v-if="images && images.length" class="pa-0">
          <!-- Big Image -->
          <v-row no-gutters justify="center">
            <v-col lg="8" md="8" cols="12">
              <v-card tile flat class="py-3">
                <v-img :src="selectedImage" class="ma-1" contain />
              </v-card>
            </v-col>
          </v-row>

          <!-- Thumbnails -->
          <v-row no-gutters justify="center">
            <v-col v-for="img in images" :key="img" cols="2">
              <v-hover v-slot="{ props, isHovering }">
                <v-card
                  class="mx-1"
                  max-width="100"
                  tile
                  outlined
                  v-bind="props"
                  :color="
                    img === selectedImage
                      ? 'primary'
                      : isHovering
                      ? 'primary'
                      : 'white'
                  "
                  @click="selectedImage = img"
                >
                  <v-img :src="img" max-width="100" />
                </v-card>
              </v-hover>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mdiWindowClose } from "@mdi/js";

export default {
  name: "ImageDialog",

  props: {
    modelValue: Boolean, // for v-model
    images: Array, // image list
    title: {
      type: String,
      default: "Product Images",
    },
  },

  data() {
    return {
      selectedImage: null,
      mdiWindowClose,
    };
  },

  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },

  watch: {
    images: {
      handler(newValue) {
        if (newValue && newValue.length) {
          this.selectedImage = newValue[0];
        }
      },
      immediate: true,
    },
  },

  methods: {
    close() {
      this.model = false;
    },
  },
};
</script>
